<template>
  <o-form-group :label="label" :error-field="errorField" :class="{'has-error': errorField in $root.errors}">
    <div class="w-100">
      <div class="input-group">
        <vue-monthly-picker v-model="localValue" :monthLabels="monthLabels" :dateFormat="dateFormat"
                            class="form-control-month">
        </vue-monthly-picker>
        <div class="month-group-append">
          <button class="btn btn-outline-secondary" type="button" disabled>
            <fa icon="calendar"></fa>
          </button>
        </div>
      </div>
    </div>
  </o-form-group>
</template>

<style lang="scss">
  .form-control-month {
    display: block !important;
    width: 100% !important;
    height: calc(1.5em + 0.75rem + 2px) !important;
    padding: 0 !important;
    font-size: 1rem !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    color: #495057 !important;
    background-color: #fff !important;
    background-clip: padding-box !important;
    border: 1px solid #ced4da !important;
    border-radius: 0.125rem !important;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
  }
  .vue-monthly-picker .input {
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
  .month-group-append {
    position: absolute;
    margin-left: -1px;
    display: flex;
    right: 0;
    .btn {
      cursor: default;
    }
  }
  .vue-monthly-picker .vmp-input-append {
    right: 40px !important;
  }
</style>


<script>
  import VueMonthlyPicker from 'vue-monthly-picker'
  import moment from 'moment'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

  export default {
    name: 'o-monthpicker',
    props: {
      value: {
        default: null
      },
      label: {
        type: String
      },
      dateFormat: {
        type: String,
        default: 'MMMM YYYY'
      },
      dayOfTheMonth: {
        type: String,
        default: 'first'
      },
      errorField: {
        type: String
      },
    },

    data: () => ({
      localValue: '',
      monthLabels: []
    }),

    mounted() {
      this.localValue = this.value
        this.monthLabels = [
          this.$i18n.t('core.january_long'),
          this.$i18n.t('core.february_long'),
          this.$i18n.t('core.march_long'),
          this.$i18n.t('core.april_long'),
          this.$i18n.t('core.may_long'),
          this.$i18n.t('core.june_long'),
          this.$i18n.t('core.july_long'),
          this.$i18n.t('core.august_long'),
          this.$i18n.t('core.september_long'),
          this.$i18n.t('core.october_long'),
          this.$i18n.t('core.november_long'),
          this.$i18n.t('core.december_long')
        ]
    },
    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal === null) {
              this.localValue = ''
          } else {
              this.localValue = newVal
          }
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          if(this.dayOfTheMonth === 'last') {
            this.$emit('input', newVal ? moment(newVal).endOf('month').format('YYYY-MM-DD') : null)
          } else {
            this.$emit('input', newVal ? moment(newVal).startOf('month').format('YYYY-MM-DD') : null)
          }
        }
      }
    },
    components: {
        VueMonthlyPicker,
        FontAwesomeIcon
    },
  }
</script>
